import clsx from "clsx";
import { CC_PANEL, CC_SECTION_LABEL } from "@/components/case-checking/caseCheckingChrome";
import type { CaseTimeline } from "@/services/api/case-checking";

export function TimelineStoryPanel({ timeline }: { timeline: CaseTimeline | null }) {
  const hasStory = Boolean(timeline?.narrative?.trim());

  if (!hasStory) {
    return (
      <div className={clsx(CC_PANEL, "text-sm text-slate-500")} data-testid="timeline-story-empty">
        No case story yet. The agent builds this from the file after document triage.
      </div>
    );
  }

  return (
    <div className={CC_PANEL} data-testid="timeline-story-panel">
      <p className={clsx(CC_SECTION_LABEL, "mb-2")}>Story</p>
      <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300 whitespace-pre-wrap">{timeline!.narrative}</p>
      {timeline!.anchor_date ? (
        <p className="mt-3 text-xs text-slate-500">
          Anchor: {timeline!.anchor_date}
          {timeline!.anchor_reasoning ? ` — ${timeline!.anchor_reasoning}` : ""}
        </p>
      ) : null}
    </div>
  );
}
